const rewritePath = [
    '/business#/order/unprocessed',
    '/business#/order/history',
    '/business#/order/search',
    '/business#/order/afterSaleAudit/orders',
    '/business#/order/preMealReportInfo',
    '/business#/order/prepMealReport',
    '/business#/order/preMealRights',
    '/business#/order/preOrderSettings',
    '/business#/order/instantRefundSettings',
    '/business#/order/unPunctualOrder',
    '/business#/order/refundReportInfo',
];

const rewritePathToUnified = (val: string): string => {
    let result = '';
    const hit =
        rewritePath.find(path => {
            return val.indexOf(path) > 0;
        }) || '';
    if (hit) {
        result = val.replace('/business#/', '/orderbusiness#/').replace('#/new_fe', '/new_fe');
    }
    return result;
};

export default rewritePathToUnified;
